import { render, staticRenderFns } from "./groupBuyRecord.vue?vue&type=template&id=373c90db&"
import script from "./groupBuyRecord.vue?vue&type=script&lang=ts&"
export * from "./groupBuyRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "groupBuyRecord.vue"
export default component.exports